module.exports = __webpack_public_path__ + "img/palmfooter.dc6e7bab.png";